/* Bundle tiers: clicking a tier sets the product form quantity.
   The discount itself is a Shopify automatic discount applied at checkout --
   this only drives quantity, it never claims a price the cart won't honour. */
(function () {
  function init(scope) {
    var wrap = (scope || document).querySelector('.arc-bundle');
    if (!wrap || wrap.dataset.arcReady) return;
    wrap.dataset.arcReady = '1';

    var form = wrap.closest('product-info, .product__info-container, form') || document;
    var tiers = wrap.querySelectorAll('[data-arc-tier]');

    function qtyInput() {
      return document.querySelector('.product-form__input[name="quantity"], quantity-input input[name="quantity"], input.quantity__input');
    }

    tiers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = qtyInput();
        if (input) {
          input.value = btn.dataset.qty;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        tiers.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      });
    });

    // keep the tiers honest if the shopper edits quantity directly
    var input = qtyInput();
    if (input) {
      input.addEventListener('change', function () {
        tiers.forEach(function (b) {
          b.setAttribute('aria-pressed', b.dataset.qty === String(input.value) ? 'true' : 'false');
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (document.readyState !== 'loading') init(document);
})();
